import(/* webpackMode: "eager" */ "/home/igor/meet/app/page.tsx");
